import { render } from "./EditSummaryModal.vue?vue&type=template&id=52653811&scoped=true"
import script from "./EditSummaryModal.vue?vue&type=script&lang=js"
export * from "./EditSummaryModal.vue?vue&type=script&lang=js"

import "./EditSummaryModal.vue?vue&type=style&index=0&id=52653811&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52653811"]])

export default __exports__